import React from 'react';
import classNames from 'classnames';
import './index.scss';

const SectionItemInlineLabel = ({ column }) => {
    return (
        <div
            key={`sectionItemInlineLabel-${column.accessor}`}
            className={classNames("sectionItemInlineLabel", column.inlineType)}
            style={{ width: column?.width, height: column?.height, minHeight: column?.height ? 'unset' : '45px' }}
        >
            <div>{column?.label || ''}</div>
        </div>
    );
};

export default SectionItemInlineLabel;
